import styles from './Page404.module.css'
import Header from './components/Header.js';
import { useEffect } from 'react';
import { Link } from "react-router-dom";
import background from './assets/img/background.png';

export default function Page404() {

    useEffect(() => {
        document.title = "Страница не найдена - Coperand recipes";
    }, []);

    return (
        <>
            <div className={styles.main_column}>
                <Header/>
                <main className={styles.main} style={{backgroundImage: `url(${background})`}}>
                    <h1 className={styles.header_404}>Страница не найдена</h1>
                    <Link to="/"><button className={styles.to_main_button}>На главную</button></Link>
                </main>
            </div>
        </>
    );
}
